import { render } from "./OrdersEdit.vue?vue&type=template&id=622d740f"
import script from "./OrdersEdit.vue?vue&type=script&lang=js"
export * from "./OrdersEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__